import {isArray} from 'lodash';
import React, {memo, useEffect, useRef} from 'react';
import NotificationSystem from 'react-notification-system';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';

interface Props {
  children: React.ReactNode;
}

const BaseLayout = ({children}: Props) => {
  const notificationSystem = useRef(null);
  const {error, success} = useSelector((state: RootState) => state.ui.messages);

  useEffect(() => {
    if (error) {
      const notification = notificationSystem.current;
      if (notification) {
        if (isArray(error)) {
          // @ts-ignore
          notification.addNotification({
            title: 'Validation error!',
            level: 'error',
            position: 'tc',
            autoDismiss: 5,
            children: (
              <div>
                {error.map(e => (
                  <p key={e}>{e}</p>
                ))}
              </div>
            ),
          });
        } else {
          // @ts-ignore
          notification.addNotification({
            title: 'Oops, something went wrong!',
            message: error,
            level: 'error',
            position: 'tc',
            autoDismiss: 5,
          });
        }
      }
    }
  }, [error]);

  useEffect(() => {
    if (success) {
      const notification = notificationSystem.current;
      if (notification) {
        // @ts-ignore
        notification.addNotification({
          title: 'Success!',
          message: success,
          level: 'success',
          position: 'tc',
          autoDismiss: 5,
        });
      }
    }
  }, [success]);

  return (
    <div style={{position: 'relative', height: '100vh'}}>
      <NotificationSystem ref={notificationSystem} style={notifOverrideStyle} />
      {children}
    </div>
  );
};

const notifOverrideStyle = {
  Containers: {
    DefaultStyle: {
      zIndex: 99999,
    },
  },
};

export default memo(BaseLayout);
